'use client'
import React, { useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import ProductThumbnail from "./ProductThumbnail";
import { CustomDragPreview } from "./ProductListView";
import ProductFavoriteButton from "../FavoriteButtons/ProductFavoriteButton";
import ProductOptionComponent from "../product/product_options";
import trackRecentlyViewedItem from "@/pages/api/trackRecentlyViewedItem";
interface EachProductCardProps {
    eachProduct: any;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}
const EachProductCard: React.FC<EachProductCardProps> = (props) => {
    console.log('EachProductCard component----------------------------------')
    //props
    const { eachProduct, handleCloseProductDetails, handleSelectedProductDetailId } = props
    //state
    const [hoverState, setHoverState] = useState<{ [key: number]: string | null }>({});
    //handlers
    const handleHover = (productId: number, image: string) => {
        setHoverState((prev) => ({
            ...prev,
            [productId]: image,
        }));
    };

    const handleHoverOut = (productId: number) => {
        setHoverState({});
    };
    const handleDetailsClick = (event: any) => {
        event.stopPropagation();
        handleSelectedProductDetailId(eachProduct.productId)
        handleCloseProductDetails(false)
        trackRecentlyViewedItem({
            itemId: eachProduct.productId,
            type: 'product',
            name: eachProduct.productName,
            image: eachProduct.productImage,
            price: eachProduct.price,
            comparePrice: eachProduct.comparePrice,
            model3dUrl: eachProduct.model3dUrl,
        });
    }
    const productImage = (eachProduct.productId && hoverState?.[eachProduct.productId]) && hoverState[eachProduct.productId];
    //root return of jsx
    return <Box key={eachProduct.productId} component="div" sx={{ display: 'flex', position: 'relative', overflow: 'hidden', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center', margin: '0 8px 15px 8px', textAlign: 'center', padding: '5px', border: '2px solid #DDD', borderRadius: '8px', '&:hover': { border: '2px solid #0D908E', borderRadius: '8px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)' } }}>
        {/* <img src={eachProduct.productImage} style={{ width: '150px', height: '150px' }} /> */}
        <Tooltip title={<Typography fontSize={14} color={'white'}>Drag and drop to add product to the room</Typography>} arrow PopperProps={{ style: { zIndex: 99999999, width: 200, opacity: 0.75 }, modifiers: [{ name: "offset", options: { offset: [0, 0], }, },], }} placement="right">
            <Box component="span" sx={{ cursor: 'pointer', display: 'inline-block', backgroundColor: 'white' }}>
                <ProductThumbnail product={{ ...eachProduct, ...(productImage ? { productImage } : {}) }} />
            </Box>
        </Tooltip>
        {eachProduct?.availability?.toLowerCase() !== 'available' && <Box component="div" sx={{ position: 'absolute', background: 'rgba(255,255,255,0.7)', width: '100%', top: '0', left: '0', bottom: '0', right: '0', color: '#000', fontSize: '13px', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>unavailable</Box>}
        {eachProduct?.availability?.toLowerCase() === 'available' && <CustomDragPreview />}
        <Box component='div' sx={{ position: 'absolute', left: '10px', top: '10px' }}>
            <ProductFavoriteButton eachProduct={eachProduct} fontSize='20px' />
        </Box>
        <Typography sx={{ color: '#000', fontWeight: '700' }}>{eachProduct.productName}</Typography>
        <Typography sx={{ color: '#000' }}><Box component="span" sx={{ color: '#0D908E' }}>{eachProduct?.availability?.toLowerCase() !== 'available' && 'Not'} In Stock</Box> • Free Shipping</Typography>
        <Typography sx={{ color: '#000' }}>{parseInt(eachProduct.comparePrice as any) > parseInt(eachProduct.price as any) && <Box component="span" sx={{ textDecoration: 'line-through' }}>${eachProduct.comparePrice}</Box>} <Box component="span" sx={{ color: '#0D908E' }}>${eachProduct.price}</Box></Typography>
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center' }}>{eachProduct?.productVariants?.color?.data?.length > 0 && <ProductOptionComponent page='category' type='color' selectedProductId={eachProduct.productId} option={eachProduct?.productVariants?.color} hoverState={hoverState} onHover={handleHover} onHoverOut={handleHoverOut} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId}/>}</Box>
        <Typography sx={{ color: '#0D908E',fontSize:"14px", fontWeight: '700', cursor: 'pointer' }} onClick={handleDetailsClick}>Details</Typography>
    </Box>
}
export default EachProductCard